import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";

import Button from "react-bootstrap/Button";

import HomeNavbar from "./HomeNavbar.js";


export default function Home ()
{
    const navigate = useNavigate();
    return (
	<>
	    <div className="sticky-top">
		<HomeNavbar/>
	    </div>
	    <Container>
		<div className="d-flex flex-column align-items-center gap-3 mt-5">
		    <Button size="lg" variant="primary" className="w-50" onClick={() => navigate("/play")}>Rejoindre une simulation</Button>
		    <Button size="lg" variant="primary" className="w-50" onClick={() => navigate("/admin")}>Créer et gérer des simulations</Button>
		</div>
	    </Container>
	</>
    );
}
